import { Box, Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';

const CustomGridLoader = () => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowLoader(true), 50);
    }, []);

    return showLoader ? (
        <Box
            className="background-color-l ronchik"
            sx={{
                height: '100%',
                width: '100%',
            }}
        >
            {Array.from({ length: 10 }).map((_item, index) => (
                <Box
                    sx={{
                        height: 80,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderTop: '1px solid',
                        ...(index === 0 && { borderBottom: '1px solid' }),
                    }}
                    className="divider-border-color"
                    key={index}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minWidth: 50,
                            maxWidth: 50,
                        }}
                    >
                        <Skeleton sx={{ width: 18, height: 18 }} />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <Skeleton sx={{ width: 20, height: 20 }} />
                            <Box
                                sx={{
                                    ml: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 50,
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Skeleton sx={{ width: 180, height: 20 }} />
                                <Skeleton sx={{ width: 35, height: 20 }} />
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Skeleton sx={{ width: 48, height: 48 }} variant="circular" />
                        <Skeleton sx={{ ml: 1, width: 180, height: 20 }} />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            height: 45,
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Skeleton sx={{ width: 16, height: 14 }} />
                            <Skeleton sx={{ ml: 1, width: 47, height: 14 }} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Skeleton sx={{ width: 17, height: 16 }} />
                            <Skeleton sx={{ ml: 1, width: 79, height: 14 }} />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Skeleton sx={{ m: 1, width: 20, height: 20 }} variant="circular" />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 150, maxWidth: 150 }}>
                        <Skeleton sx={{ width: 112, height: 45 }} />
                    </Box>
                </Box>
            ))}
        </Box>
    ) : (
        <Box
            sx={{
                height: '100%',
                zIndex: '1',
                position: 'absolute',
                width: '100%',
            }}
        ></Box>
    );
};

export default CustomGridLoader;
